import api from 'api';

export const loadFilterStatuses = api(
  'GET /api/audiences/filters/filter-statuses'
);
export const loadNetworks = api('GET /api/audiences/filters/networks');
export const loadPlatforms = api('GET /api/audiences/filters/platforms');
export const loadApplications = api('GET /api/audiences/filters/applications');
export const loadCountries = api('GET /api/audiences/filters/countries');
export const loadCreatedBy = api('GET /api/audiences/filters/created-by');
export const loadOwners = api('GET /api/audiences/filters/owners');
export const loadTypes = api('GET /api/audiences/filters/types');
